import React from "react";
import { ThemeProvider, Tooltip as MuiTooltip, createTheme, TooltipProps, Popper } from "@mui/material";
import colors from "../themes/colors";

const Tooltip = (props: TooltipProps) => {
  const theme = createTheme({
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            color: colors.primary.white1,
            fontWeight: "bold",
            backgroundColor: colors.secondary.gray20
          },
          arrow: {
            color: colors.secondary.gray20
          },
          tooltipPlacementTop: {
            marginBottom: "8px !important"
          }
        }
      }
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <MuiTooltip arrow={true} placement="top" {...props}>
        {props.children}
      </MuiTooltip>
    </ThemeProvider>
  );
};

export default Tooltip;